export function normalizePath(template: string): string {
    // if it looks like “https://…”, pull out only the pathname
    if (/^https?:\/\//i.test(template)) {
        return new URL(template).pathname;
    }

    // otherwise assume it’s already a path
    return template;
}
